import React from 'react';
import {Table, TableBody, TableCell, TableHead, TableRow, Skeleton} from '@mui/material';

const TableSuspense = ({rows = 5, columns = 4}) => {
    return (
        <Table>
            <TableHead>
                <TableRow>
                    {Array.from({length: columns}).map((_, index) => (
                        <TableCell key={index}>
                            <Skeleton width="60%"/>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {Array.from({length: rows}).map((_, rowIndex) => (
                    <TableRow key={rowIndex}>
                        {Array.from({length: columns}).map((_, colIndex) => (
                            <TableCell key={colIndex}>
                                <Skeleton/>
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default TableSuspense;
